import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { applyFlagEvent } from '../../util/flags/helpers';
import { FeatureFlagMap, FlagStreamEvent } from '../../util/flags/types';

export type FeatureFlagsState = {
  flags: FeatureFlagMap;
};

export const INITIAL_STATE: FeatureFlagsState = {
  flags: {},
};

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState: INITIAL_STATE,
  reducers: {
    featureFlagsLoaded(state: FeatureFlagsState, action: PayloadAction<FeatureFlagMap>) {
      state.flags = action.payload;
    },
    featureFlagUpdated(state: FeatureFlagsState, action: PayloadAction<FlagStreamEvent>) {
      state.flags = applyFlagEvent(state.flags, action.payload);
    },
    resetFeatureFlags() {
      return INITIAL_STATE;
    },
  },
});

export const { featureFlagsLoaded, featureFlagUpdated, resetFeatureFlags } = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
